/**
 * /community/members/<handle>/gear — the hub's Gear tab, public half (Member Hub 1b): every live
 * owner review of the member, the identity line. The same server half as the Overview
 * (`memberServerProps`: handle check, lowercase 308 to THIS page, the member and summary reads,
 * the community edge cache), the same `noindex, follow`.
 *
 * The member's own layer (Member Hub phase 3: review statuses, Add gear, candidate products)
 * hydrates inside `MemberGear` from `/me` — never in this shared-cached HTML. `guide.points` and
 * `waitingProducts` are the summary's public figures it words.
 */
import type { GetServerSideProps } from 'next'
import { publicConfig } from 'config'
import { memberGearHref } from 'lib/community/model'
import { memberServerProps, type MemberPageData } from 'lib/community/member-page'
import { CommunityShell, type CommunityPageProps } from 'lib/community/page'
import { MemberGear } from 'components/community/MemberGear'
import { MemberHub } from 'components/community/MemberHub'
import styles from 'components/community/community.module.css'

const MemberGearPage: React.VFC<CommunityPageProps<MemberPageData>> = ({
  common,
  ts,
  data: { member, guide, waitingProducts },
}) => {
  const trailingSlash = publicConfig('useTrailingSlash')
  return (
    <CommunityShell
      common={common}
      ts={ts}
      path={memberGearHref(member.handle, trailingSlash)}
      title={`${member.handle} · Gear`}
      description={`The gear ${member.handle} owns and their owner reviews in the SoundGuys community.`}
      index={false}
    >
      <div className={styles.page}>
        <MemberHub member={member} page="gear" homeHref={common.homeLink.href}>
          <MemberGear
            member={member}
            now={ts}
            points={guide?.points ?? null}
            waiting={waitingProducts}
          />
        </MemberHub>
      </div>
    </CommunityShell>
  )
}

export const getServerSideProps: GetServerSideProps<CommunityPageProps<MemberPageData>> = context =>
  memberServerProps(context, memberGearHref, { waiting: true })

export default MemberGearPage
